export default {"src":"https://cdn.jetlend.ru/_next/static/media/icon--error-alert.9a7576d4.svg","height":14,"width":14,"blurWidth":0,"blurHeight":0};